export * from './RfidTagsPage'
